import 'COMMON';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Vendor/owlcarousel/owl.carousel.min';
import { oLike } from 'Lib/like/like';
import 'Bem/site/promo/promo';
import 'Bem/journal/journal-items/journal-items';
import 'Bem/site/books-slider/books-slider';
import 'Bem/site/book/book';
import 'Bem/site/what-read/what-read';

svgSpriteLoader('/journal/main/svg/sprite.svg?v=20180320');
oLike.init('.js-book-like');